import Loader from '@/components/Loader'
import api from '@/http/api'
import { useAuthStore } from '@/store'
import { useMutation } from '@tanstack/react-query'
import { AccountSettings, type AccountData, } from '@univdiam/ui/customComponents/UserProfile'
import { useState } from 'react'
import { toast } from 'sonner'
import ManageStaff from '../ManageStaff'

const updateProfile = (data: AccountData) => {
    const normalizeData = {
        full_name: data.profile.fullName,
        email: data.profile.email,
        phone_number: data.profile.phoneNumber,
        profile_pic: data.profile.profilePicture,

        business_name: data.business.businessName,
        business_phone_number: data.business.phoneNumber,
        website: data.business.website,
        company_logo: data.business.companyLogo,
        address_line_1: data.business.addressLine1,
        address_line_2: data.business.addressLine2,
        city: data.business.city,
        state: data.business.state,
        zipCode: data.business.zipCode,

    }

    return api.post(`/customer/update`, normalizeData);
}
const Settings = () => {
    const { user, setUser } = useAuthStore()
    // const [accountData, setAccountData] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const handleSendToUpload = async (files: File[]): Promise<string[]> => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            files.forEach(file => {
                formData.append('files', file);
            });

            const response = await api.post(
                `/upload?customerId=${user?.customer_id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            const data = response.data;
            return data.files ?? [];

        } catch (error) {
            console.error('Upload failed:', error);
            return [];
        } finally {
            setIsLoading(false);
        }
    };

    const { mutateAsync, isError, isPending, error } = useMutation({
        mutationFn: (values: AccountData) => {
            return updateProfile(values)
        },
        onSuccess: async ({ data }) => {
            toast.success('User information updated successfully!', {
                position: 'top-center'
            })
            setUser(data.update)
        }
    })

    const onSave = (data: AccountData) => {
        return mutateAsync(data)
    }

    if (!user) {
        return <Loader />
    }

    return (
        <div className='max-w-4xl mx-auto pb-10'>
            <AccountSettings user={user!} handleSendToUpload={handleSendToUpload} mediaLoading={isLoading} onSave={onSave} isLoading={isPending} isError={isError} error={error} isAdmin={false} />

            {user?.role === 'CUSTOMER' && <ManageStaff />}
        </div>
    )
}

export default Settings